// extracted by mini-css-extract-plugin
module.exports = {"main":"DE7NMzawjJ37S0s6Lc0UB","icon":"_3OxHsIO_3qJwEHTym_41hy","titulo":"_2udV4ED5TeDSkPkmUlIn80","subTitulo":"_1tNKcEL39gi1dvPp-W0Ymk","back":"_2mldLCrA0_vuV-Ki9rsBQL"};